import { render, staticRenderFns } from "./Ergebnis.vue?vue&type=template&id=85b4a508&scoped=true&"
import script from "./Ergebnis.vue?vue&type=script&lang=ts&"
export * from "./Ergebnis.vue?vue&type=script&lang=ts&"
import style0 from "./Ergebnis.vue?vue&type=style&index=0&id=85b4a508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b4a508",
  null
  
)

export default component.exports